import TYPES from '@/types';

// Domain
import Inject from '@/modules/shared/domain/di/inject';
import Translator from '@/modules/shared/domain/i18n/translator';
import { Values } from '@/modules/shared/domain/i18n/types';

type RadioOption = {
  label: string;
  value: string;
};

export default class UserProfileMyDocumentsTabViewModel {
  @Inject(TYPES.I18N)
  private readonly translator!: Translator;

  readonly i18n_namespace = 'components.user-profile.user-profile-tabs.user-profile-my-documents-tab';

  translate = (message: string, values?: Values) => this.translator.translate(`${this.i18n_namespace}.${message}`, values);

  selected_document = '';

  show_update_proof_of_address_modal = false;

  show_update_bank_account_modal = false;

  show_wealth_success_modal = false;

  show_pocket_success_modal = false;

  show_bank_account_wealth_success_modal = false;

  show_bank_account_pocket_success_modal = false;

  show_ine_confirmation_modal = false;

  documents_options: Array<RadioOption> = [
    {
      label: this.translate('proof_of_address'),
      value: 'proof_of_address',
    },
    {
      label: this.translate('bank_statement'),
      value: 'bank_statement',
    },
    {
      label: this.translate('ine'),
      value: 'ine',
    },
  ];

  openModal = () => {
    if (this.selected_document === 'proof_of_address') {
      this.show_update_proof_of_address_modal = true;
    }
    if (this.selected_document === 'bank_statement') {
      this.show_update_bank_account_modal = true;
    }
    if (this.selected_document === 'ine') {
      this.show_ine_confirmation_modal = true;
    }
  }

  openSuccessModal = (document_was_wealth: boolean) => {
    if (document_was_wealth) this.show_wealth_success_modal = true;
    else this.show_pocket_success_modal = true;
  }

  openUpdatedBankAccountSuccessModal = (document_was_wealth: boolean) => {
    if (document_was_wealth) this.show_bank_account_wealth_success_modal = true;
    else this.show_bank_account_pocket_success_modal = true;
  }
}
